import { I18n } from 'i18n-js'
import en from './translations/en-US'
import pt from './translations/pt-BR'
import es from './translations/es-ES'
import { getUser } from 'presentation/utils/storage/user'

const i18n = new I18n({
  en: en,
  pt: pt,
  es: es
})

//Detecta o idioma do navegador
const detectLanguage = () => {
  //Captura o idioma do navegador (por exemplo, 'pt-BR')
  const language = navigator.language || navigator.userLanguage

  //Extrai a parte principal do idioma (exemplo: 'pt' de 'pt-BR')
  const shortLanguage = language.split('-')[0]

  //Idiomas suportados
  const supportedLanguages = ['en', 'pt', 'es']

  const dadosUserStorage = getUser()

  if (dadosUserStorage?.languageMain) {
    return dadosUserStorage?.languageMain
  } else {
    //Retorna o idioma detectado se suportado, senão retorna 'en'
    return supportedLanguages.includes(shortLanguage) ? shortLanguage : 'pt'
  }
}

//Define o idioma atual com base no navegador
i18n.locale = detectLanguage()

//Define o idioma padrão como fallback
i18n.defaultLocale = 'pt'

export const translate = key => i18n.t(key)

//Exporta a instância do i18n
export default i18n
